import React from 'react';
import styles from './styles.module.scss';
import useScreenSize from '../../hooks/useScreenSize';

const IMAGES = [
  'https://picsum.photos/seed/1/600/400',
  'https://picsum.photos/seed/2/600/400',
  'https://picsum.photos/seed/3/600/400',
  'https://picsum.photos/seed/4/600/400',
  'https://picsum.photos/seed/5/600/400',
  'https://picsum.photos/seed/6/600/400',
  'https://picsum.photos/seed/7/600/400',
  'https://picsum.photos/seed/8/600/400',
];

function OficinasGallery() {
  const { isTablet } = useScreenSize();
  const images = isTablet ? IMAGES.slice(0, 4) : IMAGES;

  return (
    <section className={styles.gallerySection}>
      <h2 className={styles.title}>Colégios que já receberam</h2>
      <div className={styles.galleryGrid}>
        {images.map((src, idx) => (
          <div className={styles.imageWrapper} key={src}>
            <img
              src={src}
              alt={`Oficina ${idx + 1}`}
              className={styles.image}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default OficinasGallery;
